<template>
    <gatewayDetail
        :isDetailShow.sync="isDetailShow"
        :title="title"
        :detailObj="detailObj"
        :deviceAssociate='deviceAssociate'
        :deviceType="deviceType"
        :deviceProperty="deviceProperty"
        :netObj="netObj"
        v-bind="$attrs"
        :completeInfo="completeInfo"
        :coordinator="coordinator"
        ref="detailDialog"
    ></gatewayDetail>
</template>

<script>

import bus from '@/utils/bus'
import gatewayDetail from './component/gatewayDetail.vue'
import { getGatewayDetailInfo } from '@/api/modules/gateway'
export default {
  props: {
    show: {
      type: Boolean
    },
    busKey: {
      type: String,
      default: 'gatewayParam'
    }
  },
  data () {
    return {
      isDetailShow: false,
      detailObj: {},
      deviceAssociate: {},
      deviceType: {},
      deviceProperty: {},
      netObj: {},
      title: '',
      // 从服务器获取的完整的详情信息
      completeInfo: {},
      coordinator: false
    }
  },
  watch: {
    isDetailShow (newval) {
      this.$emit('show', newval)
    }
  },
  components: {
    gatewayDetail
  },
  methods: {
    detailFn (id, name) {
      this.isDetailShow = true
      if (name) {
        this.title = `[${name}]${this.$t('public.details')}`
      } else {
        this.title = $t('public.gateway') + $t('public.details')
      }
      getGatewayDetailInfo(id).then(({ result }) => {
        this.completeInfo = result

        result.gateway.pictureBase64 = result.gateway.pictureBase64 || result.deviceType.pictureBase64
        // let url = `${sensor.fullPath}/${sensor.carrierName}`;
        result.gateway.url = `${result.gateway.fullPath}/${result.gateway.carrierName}`
        // 基础信息
        this.detailObj = Object.assign(result.deviceProperty || {}, result.deviceType || {}, result.gateway)
        // 属性信息
        this.deviceType = result.deviceType
        this.deviceAssociate = result.deviceAssociate || {}
        this.deviceProperty = result.deviceProperty || {}
        // 网关参数
        this.netObj = result.netConfig || {}
      })
    }
  },
  mounted () {
    bus.$on(this.busKey, (id, name, params) => {
      // 还原初始值
      this.coordinator = false

      // 是否是协调器
      if (params && params.coordinator) {
        this.coordinator = true
      }
      this.detailFn(id, name)
    })
  },
  beforeDestroy () {
    bus.$off(this.busKey)
  }
}
</script>

<style></style>
